module.exports = __webpack_public_path__ + "static/img/tool.c8148520.svg";